module.exports = __webpack_public_path__ + "static/img/dfhj_bg4.45dbd55.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/nodeService/dfhj_bg4.png
// module id = +mdM
// module chunks = 0